export enum VisitStatusCode { 
    open, 
    cancelled, 
    suspended, 
    converted 
};

export enum VisitStatus { 
    Open = "Open", 
    Cancelled = "Cancelled", 
    Suspended = "Suspended", 
    Converted = "Converted" 
};